<div class="contracts-table-wrapper">
  @if (isLoading) {
    <mat-progress-bar mode="indeterminate" class="contracts-table-loading-bar"></mat-progress-bar>
  }
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    (matSortChange)="sortChange($event)"
    class="mat-elevation-z8"
  >
    <ng-container matColumnDef="company.name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Société</th>
      <td mat-cell *matCellDef="let element">
        @let company = element.companyId | companyIdToCompany;
        <span [style.borderColor]="company ? company.companyColor : 'unset'">{{
          element.companyId | companyName
        }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="employee.lastname">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
      <td mat-cell *matCellDef="let element">{{ element.employeeLastname }}</td>
    </ng-container>

    <ng-container matColumnDef="employee.firstname">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Prénom</th>
      <td mat-cell *matCellDef="let element">{{ element.employeeFirstname }}</td>
    </ng-container>

    <ng-container matColumnDef="contract.contractType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Contrat</th>
      <td mat-cell *matCellDef="let element">
        <div class="contract-line">
          @if (element.firstContractId !== element.id) {
            <app-menu-contract-of-serie
              [firstContractId]="element.firstContractId"
              [excludeContractsId]="[element.id]"
            ></app-menu-contract-of-serie>
          } @else {
            <svg lucidePlay [size]="16" matTooltip="Initial"></svg>
          }
          <span>{{ element.contractType }}</span>
          @if (element.contractType === 'CDD R' || element.contractType === 'CDD RST') {
            <br />
            <span> {{ element.replacementFullName }}</span>
          }
        </div>
        @if (element.amendmentInProgress; as amendment) {
          <button
            type="button"
            class="amendment-line amendment-in-progress"
            data-tour-anchor="contracts-table.amendment-in-progress"
            matTooltip="Consulter l'avenant"
            (click)="consultAmendment(element)"
          >
            <svg lucideFilePenLine [size]="14"></svg>
            Avenant n°{{ amendment.number }}
          </button>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="contract.startDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Début</th>
      <td mat-cell *matCellDef="let element">
        <div class="contract-line">{{ element.startDate | frDate }}</div>
        @if (element.amendmentInProgress; as amendment) {
          <div class="amendment-line">{{ amendment.effectiveDate | frDate }}</div>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="contract.endDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Fin</th>
      <td mat-cell *matCellDef="let element">
        <div class="contract-line">{{ element.endDate | frDate }}</div>
        @if (element.amendmentInProgress; as amendment) {
          <div class="amendment-line">{{ amendment.endDate | frDate }}</div>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="contract.endOfFirstTrialPeriodDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Fin période d'essai</th>
      <td mat-cell *matCellDef="let element">
        <div class="contract-line">
          @if (element.endOfFirstTrialPeriodDate) {
            {{ element.endOfFirstTrialPeriodDate | frDate }}
          } @else {
            <span>N/A</span>
          }
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="contract.documentTags">
      <th mat-header-cell *matHeaderCellDef>Documents manquants</th>
      <td mat-cell *matCellDef="let element">
        <div class="contract-line">
          @for (tag of optionalDocuments; track $index) {
            @if (!hasDocument(element, tag) && !element.deleted) {
              @if (tag === 'socialSecurityCertificate') {
                <button
                  mat-icon-button
                  (click)="editSocialSecurity.emit(element)"
                  matTooltip="Ajouter le document de sécurité sociale"
                  aria-label="Ajouter le document de sécurité sociale"
                >
                  <app-text-icon [text]="tag | documentTagToTextIcon"></app-text-icon>
                </button>
              } @else {
                <app-add-document-to-contract
                  [contractId]="element.id"
                  [tag]="tag"
                  (contractUpdated)="updateRow(element, this.toListItem($event))"
                ></app-add-document-to-contract>
              }
            }
          }
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td mat-cell *matCellDef="let element">
        <div class="contract-line">
          <app-contract-status [small]="true" [status]="element.status"></app-contract-status>
        </div>
        @if (element.amendmentInProgress; as amendment) {
          <button
            type="button"
            class="amendment-line amendment-in-progress"
            [matTooltip]="'Consulter l’avenant n°' + amendment.number"
            (click)="consultAmendment(element)"
          >
            <app-contract-status [small]="true" [status]="amendment.status"></app-contract-status>
          </button>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="adpEditedAt">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        matTooltip="Indique si le contrat a été édité par une personne de l'ADP"
      >
        Édité
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="contract-line">
          @if (element.adpEditedAt || element.adpEditedBy) {
            <mat-icon [matTooltip]="adpEditedTooltip(element)">check</mat-icon>
          } @else {
            <mat-icon>close</mat-icon>
          }
        </div>
        @if (element.amendmentInProgress; as amendment) {
          <div class="amendment-line">
            @if (amendment.adpEditedAt || amendment.adpEditedBy) {
              <mat-icon class="amendment-icon" [matTooltip]="adpEditedTooltip(amendment)"
                >check</mat-icon
              >
            } @else {
              <mat-icon class="amendment-icon">close</mat-icon>
            }
          </div>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="signatureRequests">
      <th mat-header-cell *matHeaderCellDef>
        <app-signature-th></app-signature-th>
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="contract-line contract-signature">
          <app-yousign-summary-cell
            [signatureRequests]="element.signatureRequests"
          ></app-yousign-summary-cell>
          <app-signature-send-failure [contract]="element"></app-signature-send-failure>
        </div>
        @if (element.amendmentInProgress; as amendment) {
          <div class="amendment-line">
            <app-yousign-summary-cell
              [signatureRequests]="amendment.signatureRequests"
              [compact]="true"
            ></app-yousign-summary-cell>
            <app-signature-send-failure [contract]="amendment"></app-signature-send-failure>
          </div>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let element">
        <div class="contract-line contract-actions">
          <div>
            <!-- Action de consultation -->
            @if (element.status !== 'DRAFT' || element.deleted) {
              <button matTooltip="Voir le formulaire" mat-icon-button (click)="edit(element)">
                <svg lucideEye class="info"></svg>
              </button>
              <app-button-contract-pdf
                [contract]="element"
                (documentReady)="documentService.preview($event)"
              ></app-button-contract-pdf>
            }
            <app-button-contract-history [contract]="element"></app-button-contract-history>
            @if (mayReceiveAmendment(element)) {
              <button
                mat-icon-button
                matTooltip="Établir un avenant"
                aria-label="Établir un avenant"
                data-tour-anchor="contracts-table.establish-amendment"
                (click)="establishAmendment(element)"
              >
                <svg lucideFilePenLine class="warning"></svg>
              </button>
            }
          </div>
          <div>
            <!-- Actions de modification -->
            @if (element.status === 'DRAFT' && !element.deleted) {
              <button matTooltip="Modifier" mat-icon-button (click)="edit(element)">
                <mat-icon class="warning">edit</mat-icon>
              </button>
            }
            <app-contract-action-buttons
              [contract]="element"
              (contractUpdated)="updateRow(element, this.toListItem($event))"
              (signatureRequested)="refreshRow(element)"
              (signatureRequestFailed)="refreshRow(element)"
            ></app-contract-action-buttons>
          </div>
        </div>
        @if (element.amendmentInProgress; as amendment) {
          <div class="amendment-line amendment-actions">
            <app-amendment-action-buttons
              [amendment]="amendment"
              [contractSigned]="element.status === 'SIGNED'"
              [compact]="true"
              (documentReady)="documentService.preview($event)"
            ></app-amendment-action-buttons>
          </div>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <ng-container matColumnDef="no-data">
      <td
        mat-footer-cell
        *matFooterCellDef
        [attr.colspan]="displayedColumns.length"
        class="text-center"
      >
        Aucun résultat
      </td>
    </ng-container>
    @if (dataSource$ | async; as page) {
      @if (page.content.length === 0) {
        <tr mat-footer-row *matFooterRowDef="['no-data']" class="no-data"></tr>
      }
    }
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      [class.contract-deleted]="row.deleted"
      [class.has-amendment]="!!row.amendmentInProgress"
    ></tr>
  </table>
  <div class="contracts-table-footer">
    <mat-paginator
      [length]="length"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="[20, 50, 100]"
      (page)="paginate($event)"
    ></mat-paginator>
  </div>
</div>
